import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../store/actions/PracticeTestActions';

export const usePracticeTestData = () => {
  const params = useParams();
  const dispatch = useDispatch();

  const assessment = useSelector(state => state.practiceTest.practiceAssessmentResult);
  const curr_submission = useSelector(state => state.practiceTest.activeSubmission);
  const code = useSelector(state => state.practiceTest.activeSubmission?.code_to_execute);
  const curr_question = useSelector(state => state.practiceTest.activeQuestion);
  const recordings = useSelector(state => state.practiceTest.recordings);
  const test_cases = useSelector(state => state.practiceTest.testCases || []);
  const submissions = useSelector(state => state.practiceTest.submissions);

  useEffect(() => {
    if (params.assessmentId) {
      dispatch(actions.fetchPracticeAssessmentResult(params.assessmentId));
      dispatch(actions.fetchPracticeRecordings(params.assessmentId));
    }
  }, [params.assessmentId, dispatch]);

  useEffect(() => {
    if (
      curr_question &&
      curr_question.type === 'coding' &&
      curr_question.id &&
      params.assessmentId
    ) {
      dispatch(actions.fetchPracticeTestCases(curr_question.id));
      dispatch(actions.fetchPracticeSubmissions(params.assessmentId, curr_question.id));
    }
  }, [curr_question?.id, curr_question?.type, params.assessmentId, dispatch]);

  return {
    assessment,
    curr_submission,
    code,
    curr_question,
    recordings,
    test_cases,
    submissions,
  };
};
